import React, { useEffect } from "react";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";
import SupportRequestedComponent from "../../components/applicationComponents/supportRequested/SupportRequestedComponent";

export default function SupportRequestedPage() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Support Requested",
      icon: "view-app-icon mr-3 mt-0",
    });
  }, []);

  return (
    <>
      <SupportRequestedComponent disabled={false} />
    </>
  );
}
